import { useAuth } from '../../metodos/AuthContext';
import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import PasswordWidget from './Modulos/PasswordWidget';

const CambiarContrasena = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { verifyResetCode, confirmReset } = useAuth(); // Obtenemos las funciones del contexto

  const oobCode = searchParams.get('oobCode');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [status, setStatus] = useState({ loading: true, error: '', success: false });

  const isPasswordValid = 
    password.length >= 8 &&
    /\d/.test(password) &&
    /[A-Z]/.test(password) &&
    /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/.test(password) &&
    (password === confirmPassword && password.length > 0);
    
  // 1. Validar el enlace apenas carga la página
  useEffect(() => {
    if (oobCode) {
      verifyResetCode(oobCode)
        .then((userEmail) => {
          setEmail(userEmail);
          setStatus(prev => ({ ...prev, loading: false }));
        })
        .catch(() => {
          setStatus({ loading: false, error: 'El enlace ha expirado o es inválido.', success: false });
        });
    } else {
      setStatus({ loading: false, error: 'Acceso no autorizado.', success: false });
    }
  }, [oobCode, verifyResetCode]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      return setStatus(prev => ({ ...prev, error: 'Las contraseñas no coinciden.' }));
    }

    try {
      setStatus(prev => ({ ...prev, loading: true, error: '' }));
      await confirmReset(oobCode, password);
      setStatus({ loading: false, error: '', success: true });
      
      // Redirigir después de 3 segundos
      setTimeout(() => navigate('/login'), 3000);
    } catch (err) {
      setStatus({ loading: false, error: 'No se pudo actualizar la contraseña.', success: false });
    }
  };

  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    if (name === "contrasena") setPassword(value);
    if (name === "confirmarContrasena") setConfirmPassword(value);
  };

  if (status.loading && !email) return <div style={styles.container}>Verificando seguridad...</div>;

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2 style={styles.title}>🔐 Dufy Asesorías</h2>
        <p style={styles.subtitle}>Restablecer contraseña para:<br/><strong>{email}</strong></p>

        {status.error && <div style={styles.errorBox}>{status.error}</div>}
        {status.success && <div style={styles.successBox}>¡Contraseña cambiada! Redirigiendo...</div>}

        {!status.success && !status.error && (
          <form onSubmit={handleSubmit} style={styles.form}>
            
            <PasswordWidget 
              password={password}
              confirmPassword={confirmPassword}
              onChange={handlePasswordChange}
              namePassword="contrasena"
              nameConfirm="confirmarContrasena"
            />

            <button 
              type="submit" 
              style={{
                ...styles.button,
                backgroundColor: isPasswordValid ? '#003366' : '#ccc',
                cursor: isPasswordValid ? 'pointer' : 'not-allowed',
                marginTop: '20px'
              }} 
              disabled={status.loading || !isPasswordValid}
            >
              {status.loading ? 'Actualizando...' : 'Cambiar Contraseña'}
            </button>

          </form>
        )}
      </div>
    </div>
  );
};

// Estilos rápidos con el azul de Dufy
const styles = {
  container: { height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#f4f7f6' },
  card: { padding: '40px', background: '#fff', borderRadius: '10px', boxShadow: '0 4px 15px rgba(0,0,0,0.1)', width: '350px', textAlign: 'center' },
  title: { color: '#003366', marginBottom: '10px' },
  subtitle: { fontSize: '14px', color: '#666', marginBottom: '20px' },
  input: { width: '100%', padding: '12px', margin: '10px 0', borderRadius: '5px', border: '1px solid #ddd', boxSizing: 'border-box' },
  button: { width: '100%', padding: '12px', backgroundColor: '#003366', color: '#fff', border: 'none', borderRadius: '5px', cursor: 'pointer', fontWeight: 'bold' },
  errorBox: { padding: '10px', backgroundColor: '#ffdce0', color: '#af233a', borderRadius: '5px', marginBottom: '10px' },
  successBox: { padding: '10px', backgroundColor: '#e6fffa', color: '#236969', borderRadius: '5px' }
};

export default CambiarContrasena;